<template>
  <div class="notification-content">
    <div class="notification-icon">
      <i class="mdi" :class="icon"></i>
    </div>
    <div class="notification-body">
      <div class="notification-title">{{ title }}</div>
      <div v-if="message" class="notification-message" v-html="message"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastNotification',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-bell'
    }
  }
};
</script>

<style scoped>
/* Стили уже в toast-notifications.scss */
</style>

